import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

import Avatar from "../images/avathr.png";

const Testimonials = () => {
  const testimonials = [
    {
      role: "SHG Leader",
      testimonial:
        "WiSE has transformed our lives completely. From a small group of 10 women, we have grown to 65 members. The fair pricing system using IoT technology ensures we get the right value for our milk. My monthly income has increased by 300%.",
      image: Avatar,
      rating: 5,
      achievement: "Income increased from ₹3,000 to ₹12,000 per month",
    },
    {
      role: "Dairy Entrepreneur",
      testimonial:
        "The training programs provided by WiSE gave me the confidence to start my own dairy business. The IoT milk analyzer ensures quality, and the buy-back guarantee gives us security. Now I supply to multiple outlets.",
      image: Avatar,
      rating: 5,
      achievement: "Started successful dairy enterprise with 20+ cows",
    },
    {
      role: "SHG Member",
      testimonial:
        "Before WiSE, we faced problems with milk pricing and quality testing. Now, with their advanced technology and fair pricing system, we get better rates for our milk. The regular health camps for our cattle are also very helpful.",
      image: Avatar,
      rating: 5,
      achievement: "Consistent 15% higher prices for quality milk",
    },
    {
      role: "Young Entrepreneur",
      testimonial:
        "WiSE supported me in starting my value-added dairy products business. Their training on paneer and ghee making was excellent. Today, I supply these products to local markets and earn a decent living for my family.",
      image: Avatar,
      rating: 5,
      achievement: "Launched 5 value-added dairy products",
    },
    {
      role: "SHG Coordinator",
      testimonial:
        "The technology integration by WiSE is revolutionary. The mobile app helps us track our milk supply, quality reports, and payments. The transparency in the system has built great trust among our members.",
      image: Avatar,
      rating: 5,
      achievement: "Coordinating 45+ women across 3 villages",
    },
    {
      role: "Dairy Farmer",
      testimonial:
        "WiSE not only helps us with fair pricing but also provides regular veterinary support for our cattle. The health camps and awareness programs have improved our cattle health significantly, leading to better milk production.",
      image: Avatar,
      rating: 5,
      achievement: "40% increase in milk production per cow",
    },
  ];

  const impactStats = [
    { number: "65+", label: "Women Empowered", icon: "👩‍💼" },
    { number: "300%", label: "Average Income Increase", icon: "📈" },
    { number: "500+", label: "Liters Processed Daily", icon: "🥛" },
    { number: "5+", label: "Villages Covered", icon: "🏘️" },
    { number: "100%", label: "Fair Price Guarantee", icon: "✅" },
    { number: "24/7", label: "Support Available", icon: "🤝" },
  ];

  const successStories = [
    {
      title: "From Housewife to Entrepreneur",
      story:
        "Lakshmi started as a housewife with 2 cows. Through WiSE training and support, she now manages a dairy unit with 15 cows and leads a team of 20 women.",
      impact: "Monthly income increased from ₹5,000 to ₹25,000",
    },
    {
      title: "Technology Adoption Success",
      story:
        "Meera was initially hesitant about using IoT technology. After training, she became the first to adopt digital milk testing and now helps train other SHG members.",
      impact: "20% better prices due to quality assurance",
    },
    {
      title: "Community Leadership",
      story:
        "Kamala transformed from a shy member to a confident SHG leader, representing her village in government meetings and policy discussions.",
      impact: "Leading 45+ women across multiple programs",
    },
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span
        key={index}
        className={index < rating ? "text-warning" : "text-light"}
      >
        ⭐
      </span>
    ));
  };

  return (
    <div className="fade-in">
      {/* Hero Section */}
      <section
        className="py-5 text-white hero_sec"
        style={{ background: "linear-gradient(135deg, #2E8B57, #4682B4)" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-3">Success Stories</h1>
              <p className="fs-5">
                Real stories from the women whose lives have been transformed by
                WiSE
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Impact Statistics */}
      <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-4">
              <h2 className="display-6 fw-bold mb-3">Our Impact</h2>
            </Col>
          </Row>
          <Row>
            {impactStats.map((stat, index) => (
              <Col md={4} lg={2} key={index} className="text-center mb-4">
                <div className="p-3">
                  <div style={{ fontSize: "2rem" }}>{stat.icon}</div>
                  <div className="display-6 fw-bold text-primary">
                    {stat.number}
                  </div>
                  <p className="small text-muted">{stat.label}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Testimonials */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">What Our Members Say</h2>
              <p className="fs-5 text-muted">
                Hear directly from the women who have experienced transformation
              </p>
            </Col>
          </Row>
          <Row>
            {testimonials.map((testimonial, index) => (
              <Col lg={6} key={index} className="mb-4">
                <Card className="border-0 shadow card-hover h-100">
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-center mb-3">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                        className="me-3"
                      />
                      <div className="flex-grow-1">
                        <h5 className="fw-bold mb-1">{testimonial.name}</h5>
                        <p className="small text-muted mb-1">
                          {testimonial.role}
                        </p>
                        <div className="mb-1">
                          {renderStars(testimonial.rating)}
                        </div>
                      </div>
                    </div>
                    <blockquote className="mb-3">
                      <p className="text-muted fst-italic">
                        "{testimonial.testimonial}"
                      </p>
                    </blockquote>
                    <div className="bg-success bg-opacity-10 p-3 rounded">
                      <small className="text-success fw-semibold">
                        Achievement:{" "}
                      </small>
                      <small className="text-success">
                        {testimonial.achievement}
                      </small>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Success Stories */}
      <section
        className="section-padding"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">
                Detailed Success Stories
              </h2>
              <p className="fs-5 text-muted">
                In-depth look at transformation journeys
              </p>
            </Col>
          </Row>
          <Row>
            {successStories.map((story, index) => (
              <Col lg={4} key={index} className="mb-4">
                <Card className="border-0 shadow hover-lift h-100">
                  <Card.Body className="p-4">
                    <Card.Title className="fw-bold h5 text-primary">
                      {story.title}
                    </Card.Title>
                    <Card.Text className="text-muted mb-3">
                      {story.story}
                    </Card.Text>
                    <div className="border-start border-success ps-3 bg-light p-3 rounded">
                      <small className="text-success fw-semibold">
                        Impact:{" "}
                      </small>
                      <small className="text-success">{story.impact}</small>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Community Testimonial */}
      <section className="section-padding">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <Card className="border-0 shadow-lg testimonial-card">
                <Card.Body>
                  <h3 className="fw-bold text-primary mb-3">
                    Community Impact
                  </h3>
                  <blockquote className="fs-5 fst-italic text-muted mb-4">
                    "WiSE has not just changed individual lives, but transformed
                    entire village economies. The ripple effect of women's
                    empowerment is visible in improved education for children,
                    better healthcare access, and overall community
                    development."
                  </blockquote>
                  <div className="d-flex align-items-center">
                    <img
                      src="https://images.pexels.com/photos/1181717/pexels-photo-1181717.jpeg?auto=compress&cs=tinysrgb&w=300&h=300&dpr=2"
                      alt="Village Leader"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                      className="me-3"
                    />
                    <div>
                      <h6 className="fw-bold mb-0">Dr. Radha Krishnan</h6>
                      {/* <small className="text-muted">
                        Village Development Officer
                      </small> */}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/2280549/pexels-photo-2280549.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&dpr=2"
                alt="Community gathering"
                className="img-fluid rounded shadow-lg hover-lift"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Call to Action */}
      <section
        className="py-5 text-white"
        style={{ background: "linear-gradient(135deg, #2E8B57, #4682B4)" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-3">
                Be Part of the Success Story
              </h2>
              <p className="fs-5 mb-4">
                Join WiSE and write your own transformation story
              </p>
              <div className="d-flex justify-content-center gap-3">
                <button className="btn btn-light btn-lg px-4">
                  Join WiSE Today
                </button>
                <button className="btn btn-outline-light btn-lg px-4">
                  Share Your Story
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Testimonials;
